import React, { useState, useEffect } from 'react';
import axios from 'axios';

const PlatformManager = () => {
  const [platforms, setPlatforms] = useState([]);
  const [formData, setFormData] = useState({ PlatformName: '', PlatformID: null });
  const [editing, setEditing] = useState(false);
  const API = process.env.REACT_APP_API_BASE_URL;

  const token = localStorage.getItem('hostToken'); // JWT from login

  const api = axios.create({
    baseURL: `${API}/api/host`,
    headers: { Authorization: `Bearer ${token}` },
  });

  const fetchPlatforms = async () => {
    try {
      const res = await api.get('/platforms');
      setPlatforms(res.data);
    } catch (error) {
      console.error('Fetch Error:', error);
    }
  };

  useEffect(() => {
    fetchPlatforms();
  }, []);

  const handleChange = (e) => {
    setFormData({ ...formData, PlatformName: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (editing) {
        await api.put(`/platforms/${formData.PlatformID}`, { PlatformName: formData.PlatformName });
      } else {
        await api.post('/platforms', { PlatformName: formData.PlatformName });
      }
      fetchPlatforms();
      setFormData({ PlatformName: '', PlatformID: null });
      setEditing(false);
    } catch (error) {
      console.error('Submit Error:', error);
    }
  };

  const handleEdit = (platform) => {
    setFormData({ PlatformName: platform.PlatformName, PlatformID: platform.PlatformID });
    setEditing(true);
  };

  const handleDelete = async (id) => {
    if (window.confirm('Are you sure you want to delete this platform?')) {
      try {
        await api.delete(`/platforms/${id}`);
        fetchPlatforms();
      } catch (error) {
        console.error('Delete Error:', error);
      }
    }
  };

  return (
    <div className="card">
      <div className="card-header bg-primary text-white">
        <h5 className="m-0">{editing ? 'Edit Platform' : 'Add New Platform'}</h5>
      </div>
      <div className="card-body">
        <form onSubmit={handleSubmit} className="form-inline mb-4">
          <input
            type="text"
            name="PlatformName"
            className="form-control mr-2"
            placeholder="Enter Platform Name"
            value={formData.PlatformName}
            onChange={handleChange}
            required
          />
          <button type="submit" className="btn btn-success">
            {editing ? 'Update' : 'Add'}
          </button>
        </form>

        <table className="table table-bordered table-striped">
          <thead className="thead-dark">
            <tr>
              <th>#</th>
              <th>Platform Name</th>
              <th>Created Date</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {platforms.length === 0 ? (
              <tr>
                <td colSpan="4" className="text-center">No platforms found.</td>
              </tr>
            ) : (
              platforms.map((platform, index) => (
                <tr key={platform.PlatformID}>
                  <td>{index + 1}</td>
                  <td>{platform.PlatformName}</td>
                  <td>{new Date(platform.createddate).toLocaleString()}</td>
                  <td>
                    <button
                      className="btn btn-sm btn-info mr-2"
                      onClick={() => handleEdit(platform)}
                    >
                      Edit
                    </button>
                    <button
                      className="btn btn-sm btn-danger"
                      onClick={() => handleDelete(platform.PlatformID)}
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default PlatformManager;
